export default {
    repaymentFirst: "Please finish the repayment and withdraw afterwards",
    upAmount: "Repay on time to enable repeated loan with increased credit limit",
    repaymentCode: "Repayment Code",
    checkRepaymentCode: "Check Repayment Code",
};
